<!-- Scanner Input Modal -->
<div class="main-modal" *ngIf="activeModal === 'scanner'">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header py-3 px-4 border-bottom-0 d-block">
                <div class="d-flex align-items-center justify-content-between">
                    <h5 class="modal-title" id="modal-title">
                        Scan QR Code {{ scannerMode === 'camera' ? 'with Camera' : 'with Scanner' }}
                    </h5>
                    <button type="button" class="btn-close float-end" (click)="closeScanner()" data-bs-dismiss="modal"
                        aria-label="Close"></button>
                </div>
                
                <!-- Toggle Button -->
                <div class="scanner-toggle-container mt-3">
                    <div class="toggle-buttons">
                        <button 
                            class="toggle-btn" 
                            [class.active]="scannerMode === 'barcode'"
                            (click)="scannerMode !== 'barcode' && toggleScannerMode()"
                            [disabled]="scannerMode === 'barcode'">
                            <i class="ti ti-barcode"></i>
                            Scanner
                        </button>
                        <button 
                            class="toggle-btn" 
                            [class.active]="scannerMode === 'camera'"
                            [class.disabled]="!cameraSupported"
                            (click)="scannerMode !== 'camera' && cameraSupported && toggleScannerMode()"
                            [disabled]="scannerMode === 'camera' || !cameraSupported">
                            <i class="ti ti-camera"></i>
                            Camera
                        </button>
                    </div>
                </div>
            </div>
            
            <div class="modal-body rounded px-4 pb-4 pt-0">
                <!-- Barcode Scanner Interface -->
                <div *ngIf="scannerMode === 'barcode'" class="scanner-container text-center">
                    <!-- Hidden input field for barcode scanner -->
                    <input 
                        #scannerInput
                        id="scannerInput"
                        type="text" 
                        class="scanner-input"
                        (input)="onScannerInput($event)"
                        placeholder="Position cursor here and scan QR code"
                        autocomplete="off"
                        style="opacity: 0; position: absolute; left: -9999px;">
                    
                    <!-- Visual scanning interface -->
                    <div class="scanner-visual-container">
                        <div class="scanner-icon-container">
                            <i class="ti ti-qrcode scanner-icon"></i>
                            <div class="scanner-animation"></div>
                        </div>
                        <h6 class="scanner-title">Ready to Scan</h6>
                        <p class="scanner-instruction">
                            Point your barcode scanner at the QR code and scan
                        </p>
                        <div class="scanner-status">
                            <div class="status-dot active"></div>
                            <span>Scanner Active</span>
                        </div>
                    </div>
                </div>

                <!-- Camera Scanner Interface -->
                <div *ngIf="scannerMode === 'camera'" class="scanner-section">
                    <div class="scanner-frame-container position-relative">
                        <zxing-scanner 
                            [device]="currentDevice" 
                            (scanSuccess)="handleQrCodeResult($event)"
                            class="scanner-video w-100"
                            [enable]="scannerEnabled">
                        </zxing-scanner>

                        <!-- Stylish scanner frame overlay -->
                        <div class="scanner-frame">
                            <div class="scanner-corners">
                                <div class="corner top-left"></div>
                                <div class="corner top-right"></div>
                                <div class="corner bottom-left"></div>
                                <div class="corner bottom-right"></div>
                            </div>
                            <div class="scanner-line"></div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Success Modal - Visitor Card -->
<div *ngIf="activeModal === 'visitorCard'" class="main-modal success-main-modal">
    <div class="success-modal-content rounded-4 p-4">
        <div class="modal-body card-padding success-modal-body">
            <div class="close-flip-container d-flex justify-content-between">
                <button class="btn-close button-animations" type="button" (click)="closeVisitorCard()"></button>
                <button class="flip-icon button-animations" (click)="flipCard()" title="Flip"
                    [ngClass]="{ 'flip-right': frontSide, 'flip-left': backSide }" [disabled]="imageLoading">
                    <i class="ti ti-refresh"></i>
                </button>
            </div>
            <div *ngIf="imageLoading" class="skeleton-card">
        <div class="card-header" style="position: relative;">
          <div class="skeleton skeleton-header"></div>
        </div>
        
        <div class="success-profile-section">
          <div class="skeleton skeleton-text subtitle"></div>
          <div class="skeleton skeleton-avatar"></div>
          <div class="skeleton skeleton-text title"></div>
          <div class="skeleton skeleton-text short"></div>
        </div>
        
        <div class="details-section">
          <div class="row">
            <div class="col-1"></div>
            <div class="col-10">
              <div class="skeleton skeleton-text line"></div>
              <div class="skeleton skeleton-text line"></div>
            </div>
            <div class="col-1"></div>
          </div>
        </div>
      </div>
            <div [@flipCard]="cardState" style="transform-style: preserve-3d;" *ngIf="!imageLoading">
                <!-- Front Side Card -->
                <div class="sucess-visitor-card" [ngClass]="{'VIP-border': visitDetails.visitPurpose.purposeType === 'VIP'}" *ngIf="frontSide">
                    <div class="card-header">
                        <div class="green-strip-container" *ngIf="visitDetails.visitPurpose.purposeType !== 'VIP'">
                            <img src="assets/images/green-strip.svg" alt="Green Strip" class="green-strip" />
                            <div class="white-dot"></div>
                        </div>
                        <div class="green-strip-container" *ngIf="visitDetails.visitPurpose.purposeType === 'VIP'">
                            <img src="assets/images/golden-strip.svg" alt="Green Strip" class="green-strip" />
                            <div class="white-dot"></div>
                        </div>
                        <div class="ribbon" [ngClass]="{'VIP-ribbon': visitDetails.visitPurpose.purposeType === 'VIP'}">VISITOR</div>
                    </div>

                    <div class="success-profile-section">
                        <span class="welcome-text">Welcome to {{hostDetails.companyProfile.name}} </span>
                        <div class="profile-image-container" [ngClass]="{'VIP-image': visitDetails.visitPurpose.purposeType === 'VIP'}">
                        <ng-container *ngIf="visitDetails.photoUrl; else defaultVisitorAvatar">
                            <img [src]="visitDetails.photoUrl" alt="Visitor" class="image-profile">
                        </ng-container>
                        <ng-template #defaultVisitorAvatar>
                            <img src="assets/icons/Profile-create-img-new.svg" alt="No photo" class="image-profile">
                        </ng-template>
                        </div>
                        <div class="d-flex">
                            <h2 class="visitor-name long-name-ellipsis-1">{{visitDetails.visitor.firstName}}
                                {{visitDetails.visitor.lastName}}</h2>
                            <img [src]="getStatusIcon(visitDetails.visitStatus).icon" [title]="getStatusIcon(visitDetails.visitStatus).tooltip"
                                alt="Status Icon" class="status-icon">
                        </div>
                        <span class="detail-text">{{visitDetails.company || 'Company Name: Not Provided' }}</span>
                    </div>

                    <div class="details-section">
                        <div class="row">
                            <div class="col-12 detail-group-col">
                                <div class="detail-group group-1 mb-1 mt-1">
                                    <i class="ti ti-calendar"></i>
                                    <span class="detail-text">{{ visitDetails.visitDate | dateFormat }}</span>
                                </div>
                                <div class="detail-group group-1">
                                    <i class="ti ti-clock"></i>
                                    <span class="detail-text">{{ visitDetails.visitTime }}</span>
                                </div>

                                <!-- Show Blacklisted Badge if Blacklisted -->
                                <ng-container *ngIf="visitDetails.visitor.isBlacklist; else visitPurposeBlock">
                                    <span class="visit-tag blacklisted-tag mt-2">Blacklisted</span>
                                </ng-container>

                                <!-- Else Show Purpose / VIP Badge -->
                                <ng-template #visitPurposeBlock>
                                    <ng-container *ngIf="visitDetails?.visitPurpose?.purposeType === 'VIP'; else normalVisitType">
                                        <img src="assets/images/profile/vip.png" alt="VIP Visitor" class="mt-2 vip-badge">
                                    </ng-container>
                                    <ng-template #normalVisitType>
                                        <span [ngClass]="getVisitTypeClass(visitDetails.visitPurpose.purposeType)" class="mt-2 visit-tag">{{
                                            visitDetails.visitPurpose.purposeType
                                            }}</span>
                                    </ng-template>
                                </ng-template>
                            </div>
                        </div>
                    </div>

                    <div style="text-align: center;">
                        <p>Hosted by <strong>{{ visitDetails.host?.firstName }} {{ visitDetails.host?.lastName
                                }}</strong></p>
                        <hr>
                        <div class="site-link">
                            www.<span class="visitor">visitor</span><span class="bridge">bridge</span>.in
                        </div>
                    </div>
                </div>

                <!-- Back Side Card -->
                <div class="sucess-visitor-card back-side-card" [ngClass]="{'VIP-border': visitDetails.visitPurpose.purposeType === 'VIP'}" *ngIf="backSide">
                    <div class="card-header">
                        <div class="green-strip-container" *ngIf="visitDetails.visitPurpose.purposeType !== 'VIP'">
                            <img src="assets/images/green-strip.svg" alt="Green Strip" class="green-strip" />
                            <div class="white-dot"></div>
                        </div>
                        <div class="green-strip-container" *ngIf="visitDetails.visitPurpose.purposeType === 'VIP'">
                            <img src="assets/images/golden-strip.svg" alt="Green Strip" class="green-strip" />
                            <div class="white-dot"></div>
                        </div>
                        <div class="ribbon" [ngClass]="{'VIP-ribbon': visitDetails.visitPurpose.purposeType === 'VIP'}">VISITOR</div>
                    </div>
                    <div class="details-section">
                        <div class="row">
                            <div class="col-12">
                                <!-- Normal Details -->
                                <ng-container *ngIf="!showAssets && !showPurposeDetails">
                                    <!-- Email -->
                                    <div class="detail-group mt-2">
                                        <i class="ti ti-mail"></i>
                                        <span class="detail-text">{{ visitDetails.visitor.email }}</span>
                                    </div>
                
                                    <!-- Mobile -->
                                    <div class="detail-group">
                                        <i class="ti ti-device-mobile"></i>
                                        <span class="detail-text">{{ visitDetails.visitor.mobileNumber }}</span>
                                    </div>
                
                                    <!-- Gender -->
                                    <div class="detail-group">
                                        <i class="ti ti-user"></i>
                                        <span class="detail-text">
                                            {{ !visitDetails.gender
                                            ? 'Gender: Not provided'
                                            : (visitDetails.gender === 'DO_NOT_WANT_TO_SAY'
                                            ? 'Don\'t want to say'
                                            : visitDetails.gender.replaceAll('_', ' ')) }}
                                        </span>
                                    </div>
                
                                    <!-- ID Proof -->
                                    <div class="detail-group">
                                        <i class="ti ti-id"></i>
                                        <span class="detail-text">
                                            {{ (visitDetails.idProof?.proofType || visitDetails.idNumber)
                                            ? ((visitDetails.idProof?.proofType || 'Type Not provided') + ' - ' + (visitDetails.idNumber || 'N/A'))
                                            : 'ID Proof: Not provided' }}
                                        </span>
                                    </div>
                
                                    <!-- Vehicle number -->
                                    <div class="d-flex justify-content-between">
                                        <div class="detail-group" *ngIf="visitDetails.vehicleNumber">
                                            <div>
                                                <i class="ti ti-car"></i>
                                                <span class="detail-text">{{ visitDetails.vehicleNumber }}</span>
                                            </div>
                                        </div>
                                    
                                        <!-- Only Assets present -->
                                        <div *ngIf="visitDetails.assetDeclarations?.length > 0 && !(visitDetails.purposeDetails?.length > 0)">
                                            <span (click)="showAssets = true" class="detail-text text-link"
                                                style="cursor: pointer; text-decoration: underline;">
                                                View Assets
                                            </span>
                                        </div>
                                    
                                        <!-- Only Purpose Details present -->
                                        <div *ngIf="visitDetails.purposeDetails?.length > 0 && !(visitDetails.assetDeclarations?.length > 0)">
                                            <span (click)="showPurposeDetails = true" class="detail-text text-link"
                                                style="cursor: pointer; text-decoration: underline;">
                                                View Purpose Details
                                            </span>
                                        </div>
                                    
                                        <!-- Both present -> single "Other Details" dropdown -->
                                        <div *ngIf="visitDetails.assetDeclarations?.length > 0 && visitDetails.purposeDetails?.length > 0" class="dropdown">
                                            <span class="detail-text text-link dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"
                                                style="cursor: pointer; text-decoration: underline;">
                                                Other Details
                                            </span>
                                            <ul class="dropdown-menu dropdown-menu-end">
                                                <li><button type="button" class="dropdown-item" (click)="showAssets = true">View Assets</button></li>
                                                <li><button type="button" class="dropdown-item" (click)="showPurposeDetails = true">View Purpose
                                                        Details</button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    

                
                                    <!-- ID Proof Image -->
                                    <div class="id-proof-image mt-2">
                                        <img [src]="visitDetails.idProofUrl || 'assets/images/id-proof-placeholder.svg'" alt="ID Proof" class="img-fluid"
                                        style="max-width: 100%; border-radius: 8px;" />
                                    </div>
                
                                    <!-- Visit Location -->
                                    <div class="detail-group mt-2">
                                        <i class="ti ti-map-pin"></i>
                                        <span class="detail-text">{{ visitDetails.visitLocation?.location }}</span>
                                    </div>
                                </ng-container>
                
                                <!-- Assets Section -->
                                <ng-container *ngIf="showAssets">
                                <div class="assets-section mt-2">
                                    <div class="d-flex justify-content-between mb-3 sticky-top bg-white">
                                        <h5 class="mb-0">Visitor Assets</h5>
                                        <div *ngIf="visitDetails.assetDeclarations">
                                            <span *ngIf="showAssets" (click)="showAssets = false" class="detail-text text-link"
                                                style="cursor: pointer; text-decoration: underline;">Hide Assets</span>
                                        </div>
                                    </div>
                                    <div class="asset-item mb-3" *ngFor="let asset of visitDetails.assetDeclarations">
                                        <div class="asset-detail-text detail-text">
                                            <div><strong>Asset Type:</strong> {{ asset.assetType?.assetType }}</div>
                                            <div><strong>Brand:</strong> {{ asset.brand }}</div>
                                            <div><strong>Serial:</strong> {{ asset.serialNumber }}</div>
                                        </div>
                                    </div>
                                </div>
                                </ng-container>

                                <ng-container *ngIf="showPurposeDetails">
                                    <div class="assets-section">
                                        <div class="d-flex justify-content-between mb-3 sticky-top bg-white">
                                            <h5 class="mb-0">Purpose Details</h5>
                                            <span (click)="showPurposeDetails = false" class="detail-text text-link"
                                                style="cursor: pointer; text-decoration: underline;">Hide</span>
                                        </div>
                                
                                        <div class="detail-text asset-detail-text">
                                            {{ visitDetails.purposeDetails }}
                                        </div>
                                    </div>
                                </ng-container>

                            </div>
                        </div>
                    </div>
                
                    <div style="text-align: center;">
                        <hr>
                        <div class="site-link">
                            www.<span class="visitor">visitor</span><span class="bridge">bridge</span>.in
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer gap-3 px-4 py-3 border-0">
            <button *ngIf="visitDetails.visitStatus === 'Scheduled'" class="btn-back button-animations cancel-button" (click)="openCancelModal()">Deny</button>
            <!-- Check-In -->
            <button *ngIf="visitDetails.visitStatus === 'Scheduled'" class="btn close-button button-animations text-white"
                id="btn_check_in" type="button" (click)="checkedInVisit(visitDetails)"
                [ngClass]="{'disabled-button': checkInLoader}">
                {{checkInLoader ? 'Checking In...' : 'Check-In'}}
            </button>

            <!-- Check-Out -->
            <button *ngIf="visitDetails.visitStatus === 'Checked_In'" class="btn close-button button-animations text-white"
                id="btn_check_out" type="button" (click)="checkedOutVisit(visitDetails)" 
                [ngClass]="{'disabled-button': checkOutLoader}">
                {{checkInLoader ? 'Checking Out...' : 'Check-Out'}}
            </button>

        </div>
    </div>
</div>

<!-- Error Modal -->
<div class="main-modal" *ngIf="activeModal === 'error'">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header py-3 px-4 border-bottom-0 d-block">
                <button type="button" class="btn-close float-end" (click)="closeScanner()" aria-label="Close"></button>
                <h5 class="modal-title text-danger">QR Scan Error</h5>
            </div>
            <div class="modal-body text-center px-4 pb-4 pt-0">
                <img class="success-tick pb-4" src="assets/icons/Error-cross.png" alt="error-icon">
                <h5 class="card-title pb-4 text-danger">{{ errorMessage }}</h5>
                <button class="btn btn-outline-secondary mt-3" (click)="closeScanner()">Close</button>
            </div>
        </div>
    </div>
</div>

<!-- Invalid QR Error Modal -->
<div class="main-modal" *ngIf="activeModal === 'invalidQR'">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header py-3 px-4 border-bottom-0 d-block">
                <button type="button" class="btn-close float-end" (click)="closeScanner()" aria-label="Close"></button>
                <h5 class="modal-title text-danger">Invalid QR Code</h5>
            </div>
            <div class="modal-body text-center px-4 pb-4 pt-0">
                <img class="success-tick pb-4" src="assets/icons/Error-cross.png" alt="error-icon">
                <h5 class="card-title pb-4 text-danger">Invalid QR code format. Please try again.</h5>
                <button class="btn btn-outline-secondary mt-3" (click)="closeScanner()">Close</button>
            </div>
        </div>
    </div>
</div>

<!-- Unique QR Modal -->
<div class="main-modal" *ngIf="activeModal === 'uniqueQR'">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header py-3 px-4 border-bottom-0 d-block">
                <button type="button" class="btn-close float-end" (click)="closeScanner()" aria-label="Close"></button>
                <!-- <h5 class="modal-title text-danger">Invalid QR Code</h5> -->
            </div>
            <div class="modal-body text-center px-4 pb-4 pt-0">
                <img class="success-tick pb-4" src="assets/icons/Ghost-Unique.png" alt="error-icon">
                <h5 class="card-title pb-4 text-black">Oops! This QR has already walked out! 🚪</h5>
                <button class="btn btn-outline-secondary mt-3" (click)="closeScanner()">Close</button>
            </div>
        </div>
    </div>
</div>

<!-- Pending QR Modal -->
<div class="main-modal" *ngIf="activeModal === 'pendingQR'">
    <div class="modal-dialog modal-md">
        <div class="modal-content d-flex flex-column justify-content-between" style="height: 550px;">
            <div class="modal-header py-3 px-4 border-bottom-0 d-block">
                <button type="button" class="btn-close float-end" (click)="closeScanner()" aria-label="Close"></button>
                <!-- <h5 class="modal-title text-danger">Invalid QR Code</h5> -->
            </div>
            <div class="modal-body text-center px-4 py-4">
                <img class="success-tick py-4" src="assets/icons/sleeping-clock.png" alt="error-icon">
                <h5 class="card-title pb-4 text-black">⏳ Approval Pending</h5>
                <h5 class="card-title text-black">A quick nudge to your host might help 🙂</h5>
            </div>
            <div class="modal-footer border-0 justify-content-center pb-4">
                <button class="btn btn-outline-secondary" (click)="closeScanner()">Close</button>
            </div>
        </div>
    </div>
</div>

<!-- Cancel Confirmation Modal -->
<div *ngIf="activeModal === 'cancelConfirm'" class="main-modal">
    <div class="modal-main-content rounded-4 p-2">
        <div class="modal-header-section align-items-center px-4 py-3 rounded-4 modal-lg">
            <h5 class="modal-heading mb-0"></h5>
            <button class="btn-close text-end" (click)="closeCancleModal()"></button>
        </div>

        <div class="modal-body d-flex flex-column align-items-center justify-content-center px-4 py-4">
            <h3>Do you want to deny this visit?</h3>
        </div>

        <div class="modal-footer gap-3 px-4 py-3 border-0">
            <button type="button" class="no-btn button-animations cancel-button" (click)="closeCancleModal()">No</button>
            <button type="button" class="yes-btn button-animations text-white" (click)="accessDeniedVisit(visitDetails.visitId)">Yes</button>
        </div>
    </div>
</div>

<!-- ==================== CAPTURE AT GATE MODALS ==================== -->

<!-- Capture Alert Modal  -->
<div class="main-modal" *ngIf="activeModal === 'captureAlert'">
    <div class="modal-dialog modal-md">
        <div class="modal-content d-flex flex-column justify-content-between" style="height: 400px;">
            <div class="modal-header py-3 px-4 border-bottom-0 d-block">
                <button type="button" class="btn-close float-end" (click)="handleCaptureAlertClose()" aria-label="Close"></button>
                <div class="d-flex align-items-center gap-2">
                    <i class="ti ti-alert-circle text-warning" style="font-size: 21px;"></i>
                    <h5 class="mb-0 fw-semibold">Photo Capture Required</h5>
                </div>
            </div>

            <div class="modal-body text-center mx-4 my-4 px-2 d-flex flex-column align-items-center justify-content-center">
                <img class="success-tick pb-3" src="assets/icons/camera.svg" alt="camera-icon" style="width: 60px; height: 60px;">
                <h5 class="py-2 mb-0 text-black">Capture photo to complete Check-In</h5>
            </div>

            <div class="modal-footer gap-3 px-4 py-3 border-0 capture-at-gate-alert-footer">
    <button type="button" class="no-btn button-animations cancel-button" (click)="handleCaptureAlertClose()">
        Close
    </button>
    <button type="button" class="yes-btn button-animations text-white d-flex align-items-center justify-content-center"
        (click)="handleCaptureAlertCapture()">
        Capture & Check-In
    </button>
</div>
        </div>
    </div>
</div>

<!-- Capture during check-in Modal -->
<div class="main-modal" *ngIf="activeModal === 'camera'">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header py-3 px-4 border-bottom-0 d-flex justify-content-between align-items-center">
                <h5 class="modal-title mb-0">
                    <i class="ti ti-camera me-2"></i>Capture Photo
                </h5>
                <!-- <button type="button" class="btn-close" (click)="closeCamera()" aria-label="Close"></button> -->
                <button type="button" class="flip-icon button-animations" (click)="switchCamera()">
                    <i class="ti ti-refresh me-1"></i>
                </button> 
            </div>
            <div class="modal-body p-0">
                <div class="camera-container">
                    <video #videoElement class="camera-video" autoplay playsinline muted></video>
                    <canvas #canvasElement class="d-none"></canvas>
                    
                    <div class="camera-overlay">
                        <div class="camera-frame">
                            <div class="corner top-left"></div>
                            <div class="corner top-right"></div>
                            <div class="corner bottom-left"></div>
                            <div class="corner bottom-right"></div>
                        </div>
                        <div class="camera-guide-text">Align face within the frame</div>
                    </div>
                </div>
            </div>
            <div class="modal-footer gap-3 px-4 py-3 border-0 justify-content-center">
                <button type="button" class="no-btn button-animations cancel-button" (click)="closeCamera()">
                    <i class="ti ti-x me-1"></i> Cancel
                </button>
                <button type="button" class="yes-btn button-animations text-white" (click)="capturePhoto()">
                     Take Photo
                </button>               
            </div>
        </div>
    </div>
</div>

<!-- Preview Modal -->
<div class="main-modal" *ngIf="activeModal === 'preview'">
    <div class="modal-dialog modal-md">
        <div class="modal-content d-flex flex-column justify-content-between" style="min-height: 500px;">
            <div class="modal-header py-3 px-4 border-bottom-0 d-block">
                <button type="button" class="btn-close float-end" (click)="restorePreviousModal()" aria-label="Close"></button>
                <h5 class="modal-title">
                    <i class="ti ti-photo me-2"></i>Preview Photo
                </h5>
            </div>
            <div class="modal-body text-center px-4 pt-3 pt-0 d-flex flex-column align-items-center justify-content-center flex-grow-1">
                <div class="preview-image-container">
                    <img *ngIf="tempPreview" [src]="tempPreview" alt="Captured Photo" class="preview-image">
                </div>
                <p class="text-muted mt-3">Review the captured photo before saving</p>
            </div>
            <div class="modal-footer gap-3 px-4 py-3 border-0">
                <button type="button" class="no-btn button-animations cancel-button" (click)="handlePreviewChange()">
                    <i class="ti ti-refresh me-1"></i> Change
                </button>
                <button type="button" class="yes-btn button-animations text-white" (click)="handlePreviewSave()" [disabled]="captureLoader">
                    <span *ngIf="!captureLoader"><i class="ti ti-check me-1"></i> Save</span>
                    <span *ngIf="captureLoader" class="spinner-border spinner-border-sm"></span>
                </button>
            </div>
        </div>
    </div>
</div>
<div class="main-modal" *ngIf="activeModal === 'captureAlertOptional'">
    <div class="modal-dialog modal-md">
        <div class="modal-content d-flex flex-column justify-content-between" style="height: 400px;">
            <div class="modal-header py-3 px-4 border-bottom-0 d-block">
                <button type="button" class="btn-close float-end" (click)="handleCaptureAlertClose()" aria-label="Close"></button>
                <div class="d-flex align-items-center gap-2">
                    <i class="ti ti-camera text-info" style="font-size: 21px;"></i>
                    <h5 class="mb-0 fw-semibold">Add a Photo?</h5>
                </div>
            </div>

            <div class="modal-body text-center mx-4 my-4 px-2 d-flex flex-column align-items-center justify-content-center">
                <h5 class="py-2 mb-0 text-black">
                    You can capture the visitor's photo now, or Skip & check in without visitor's photo.
                </h5>
            </div>

            <div class="modal-footer gap-3 px-4 py-3 border-0 capture-at-gate-alert-footer">
                <button type="button" class="no-btn button-animations" (click)="handleCaptureAlertSkip()">
                    Skip & Check-In
                </button>
                <button type="button" class="yes-btn button-animations text-white" (click)="handleCaptureAlertCapture()">
                    Capture Photo
                </button>
            </div>
        </div>
    </div>
</div>
